import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import pagesApi from "../admincomponents/PagesApi";

export default function Showpages() {
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    pagesApi.list().then(setPages).catch(() => setError("Couldn't load page content.")).finally(() => setLoading(false));
  }, []);

  return (
    <div className="w-full">
      <div className="mb-8">
        <h1 className="text-gray-800 font-semibold text-2xl">Page Content</h1>
        <p className="text-gray-500 text-sm mt-1">Update the existing page content without changing the site structure.</p>
      </div>
      {error && <div className="mb-4 bg-red-50 border border-red-100 text-red-600 text-sm rounded-md px-4 py-3">{error}</div>}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-gray-200 bg-gray-50 text-left">
            <th className="px-6 py-4 text-gray-500 font-medium">Page</th>
            <th className="px-6 py-4 text-gray-500 font-medium">Slug</th>
            <th className="px-6 py-4 text-gray-500 font-medium">Updated</th>
            <th className="px-6 py-4 text-gray-500 font-medium text-right">Action</th>
          </tr></thead>
          <tbody>
            {loading && <tr><td colSpan={4} className="px-6 py-10 text-center text-gray-400">Loading pages...</td></tr>}
            {!loading && pages.map((page) => (
              <tr key={page.slug} className="border-b border-gray-100 last:border-0 hover:bg-gray-50">
                <td className="px-6 py-4 text-gray-800 font-medium">{page.title}</td>
                <td className="px-6 py-4 text-gray-500">/{page.slug}</td>
                <td className="px-6 py-4 text-gray-600">{page.updatedAt ? new Date(page.updatedAt).toLocaleDateString() : "—"}</td>
                <td className="px-6 py-4 text-right"><button onClick={() => navigate(`/admin/editppage/${page.slug}`)} className="text-teal-600 hover:text-teal-700 font-medium">Edit content</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}